import { geoConicConformal } from "d3-geo";
import { feature, bbox } from "topojson-client";

export async function getMapFeaturesAndBBox(url, layer) {
  return await fetch(url)
    .then((resp) => resp.json())
    .then((topojson) => {
      return {
        bbox: bbox(topojson),
        features: feature(topojson, topojson.objects[layer]),
      };
    });
}

/**
 * Returns features returned by `topojson-client` given the URL
 *
 * @param {string} url - The URL where the topojson file is located
 * @param {string} layer - The name of the map layer
 */
export async function getMapFeatures(url, layer) {
  return await fetch(url)
    .then((resp) => resp.json())
    .then((topojson) => feature(topojson, topojson.objects[layer]));
}

// from d3-stateplane
export const VirginiaNorth = geoConicConformal()
  .parallels([38 + 2 / 60, 39 + 12 / 60])
  .rotate([78 + 30 / 60, 0]);

export const VirginiaSouth = geoConicConformal()
  .parallels([36 + 46 / 60, 37 + 58 / 60])
  .rotate([78 + 30 / 60, 0]);

export const sortedGeography = function (projection) {
  const sortFunc = function (a, b) {
    const aBounds = projection.bounds(a);
    const bBounds = projection.bounds(b);
    return aBounds[0][1] < bBounds[0][1]
      ? -1
      : aBounds[0][1] > bBounds[0][1]
      ? 1
      : aBounds[0][0] < bBounds[0][0]
      ? -1
      : aBounds[0][0] > bBounds[0][0]
      ? 1
      : aBounds[1][1] < bBounds[1][1]
      ? -1
      : aBounds[1][1] > bBounds[1][1]
      ? 1
      : aBounds[1][0] < bBounds[1][0]
      ? -1
      : aBounds[1][0] > bBounds[1][0]
      ? 1
      : 0;
  };
  return sortFunc;
};
